export const contactDuplicateTranslation = {
  title: 'cng-contact_duplicate_title',
  message: 'cng-contact_duplicate_message',
  fields: {
    // This has an effect on order in the table. Do not forget to make a corresponding change in the data cells.
    locationId: 'cng-contact_duplicate-fields-location_id',
    contactId: 'cng-contact_duplicate-fields-contact_id',
    email: 'cng-contact_duplicate-fields-email',
    firstName: 'cng-contact_duplicate-fields-first_name',
    lastName: 'cng-contact_duplicate-fields-last_name',
    hpRoles: 'cng-contact_duplicate-fields-hp_roles',
    partnerId: 'cng-contact_duplicate-fields-partner_id',
    communicationName: 'cng-contact_duplicate-fields-communication_name',
    status: 'cng-contact_duplicate-fields-status',
  },
}
